<template>
  <card-info title="Session" class="information__section">
    <template v-slot:above-title>
      <h3 class="mb-4 font-weight-bold"></h3>
    </template>

    <template v-slot:below-title>
      <div v-for="(section, index) in sections" :key="section.id" class="mt-5 mb-1">
        <ListSession
          v-if="section"
          :number-of-online-meeting="learningUnit.number_of_online_meeting"
          :section="section"
          :learning-unit="learningUnit"
          :index="index"
          :show-code="false"
          :show-enroll="false"
          :show-manage-button="false"
          :show-actions="false"
          :show-timezone="true"
          :col-row="12"
          editable
        />
      </div>
    </template>
  </card-info>
</template>

<script>
import CardInfo from './CardInfo.vue';
import ListSession from '@/views/Section/components/ListSession.vue';
import Section from '@/models/Section';
import LearningUnit from '@/models/LearningUnit';

export default {
  name: 'Session',

  components: {
    CardInfo,
    ListSession
  },

  computed: {
    learningUnitId() {
      return +this.$route.params.learningUnitId;
    },

    learningUnit() {
      return this.learningUnitId
        ? LearningUnit.query()
            .with('learning_unit_type')
            .with('learning_outcome')
            .with('sections.section_repeat')
            .with('posts')
            .find(this.learningUnitId)
        : null;
    },

    sections() {
      return Section.query()
        .where('learning_unit_id', this.learningUnitId)
        .orderBy('start_at', 'asc')
        .get();
    }
  }
};
</script>

<style lang="scss">
.information__section {
  .container__section-info {
    width: 100%;
    display: flex;
    justify-content: center;

    .section__date-time,
    .meeting {
      width: 47.5%;
    }

    .section__date-time {
      white-space: normal;
    }

    .text__session-time {
      font-size: 1.1875rem;
      padding-top: 0.25rem;
    }

    .text__session-last-enrollment-date {
      padding-top: 0.5rem;
    }
  }
}
</style>
